// extracted by mini-css-extract-plugin
export default {"root":"root--y_Gl9","text":"text--ZXPSO","link":"link--JwSxW"};